<template>
  <div class="main">
    <div v-if="isMask" class="mask"></div>
    <Header @anchorScoll="scollTop" @showMask="showMask" />
    <div v-if="videoUrl && videoUrl.includes('iframe')">
      <div v-html="videoUrl" class="video-iframe"></div>
    </div>    
    <video
      v-else-if="videoUrl && !videoUrl.includes('iframe')"
      :poster="videoPost"
      class="video"
      autoplay
      loop
      controls
    >
      <source :src="videoUrl" type="video/mp4" alt="backgroundVideo" />
    </video>
    <div v-else class="cover">
      <img :src="coverImg" alt="" />
    </div>
    <div v-show="!isMobile" class="share">
      <p class="title">Share this Article</p>
      <div class="shareList">
        <p @click="copy">
          <img :src="require('@/assets/img/website/copy.png')" alt="" />
        </p>
        <a :href="sharelink_fb">
          <img :src="require('@/assets/img/website/Facebook.png')" alt="" />
        </a>
        <a :href="sharelink_ins">
          <img :src="require('@/assets/img/website/ins.png')" alt="" />
        </a>
        <a :href="sharelink_tw">
          <img :src="require('@/assets/img/website/twitter.png')" alt="" />
        </a>
        <a :href="sharelink_weibo">
          <img :src="require('@/assets/img/website/weibo.png')" alt="" />
        </a>
        <a :href="sharelink_line">
          <img :src="require('@/assets/img/website/round-grey.png')" alt="" />
        </a>
        <p @click="openWei" class="hidden_weixin">
          <img :src="require('@/assets/img/website/weixin.png')" alt="" />
        </p>
        <div v-show="isCode" id="qrcode" ref="qrcode"></div>
      </div>
    </div>
    <div v-show="isMobile" class="mbShare">
      <div @click="openShare" class="shareIcon">
        <img :src="require('@/assets/img/website/mb-share.png')" alt="" />
      </div>
      <div v-show="isShare" class="mb-shareList">
        <p @click="copy">
          <img :src="require('@/assets/img/website/mb-copy.png')" alt="" />
        </p>
        <a :href="sharelink_fb">
          <img :src="require('@/assets/img/website/mb-facebook.png')" alt="" />
        </a>
        <a :href="sharelink_ins">
          <img :src="require('@/assets/img/website/mb-ins.png')" alt="" />
        </a>
        <a :href="sharelink_tw">
          <img :src="require('@/assets/img/website/mb-twitter.png')" alt="" />
        </a>
        <a :href="sharelink_weibo">
          <img :src="require('@/assets/img/website/mb-weibo.png')" alt="" />
        </a>
        <a :href="sharelink_line">
          <img :src="require('@/assets/img/website/round-grey.png')" alt="" />
        </a>
        <p @click="nativeShareCall" class="hidden_weixin">
          <img :src="require('@/assets/img/website/mb-weixin.png')" alt="" />
        </p>
        <div v-show="isCode" id="qrcode" ref="qrcode" class="mbQrcode"></div>
      </div>
    </div>
    <div class="detail">
      <div class="teads_here1"></div> 
      <div class="title">{{ title }}</div>
      <div class="labelBox">
        <a
          v-for="(val, index) in label"
          :key="index"
          class="newsLabel"
          :href="`/list/tag/${val.toLowerCase()}`"
          >#{{ val }}</a
        >
      </div>
      <div class="date">{{ date }}</div>
      <div v-if="textVal.length != 0">
        <div v-for="(item, index) in textVal" :key="index">
          <div class="content" ref="content" v-html="item"></div>
          <div v-if="sliderImg.length != 0" class="bannerBox">
            <aCarousel arrows>
              <div slot="prevArrow" class="custom-slick-arrow">
                <img
                  v-if="!isMobile"
                  :src="require('@/assets/img/website/detailLt.png')"
                  alt=""
                />
                <img
                  v-else
                  :src="require('@/assets/img/website/mbDetailLeft.png')"
                  alt=""
                />
              </div>
              <div slot="nextArrow" class="custom-slick-arrow">
                <img
                  v-if="!isMobile"
                  :src="require('@/assets/img/website/detailRt.png')"
                  alt=""
                />
                <img
                  v-else
                  :src="require('@/assets/img/website/mbDetailRight.png')"
                  alt=""
                />
              </div>
              <div
                v-for="(item, index) in sliderImg[index]"
                :key="index"
                class="banner"
              >
                <img :src="item" alt="" />
              </div>
            </aCarousel>
          </div>
        </div>
      </div>

      <div v-else class="content" ref="content" v-html="content"></div>
      <div class="teads_here2"></div> 
    </div>
    <Footer :isMobile="isMobile" @pageTop="pageTop"  @nativeShareCall="nativeShareCall" />
  </div>
</template>

<script>
import '@/assets/css/style-rtl.min.css';
import Header from "@/views/components/header";
import Footer from "@/views/components/footer";
import Mixin from "@/util/mixin.js";
import aCarousel from "ant-design-vue/lib/carousel";

import { fetchDataApi } from "@/api/common";
import { CUSTOM_GET } from "@/util/request";

async function init(params) {
  const { code, data } = await fetchDataApi(params);
  if (code == 1511200) return data;
  return {};
}

function generateMeta({
  title = "",
  type = "",
  url = "",
  image = "",
  desc = "",
  keyword = '',
  seo_description = '',
}) {
  return `<meta name="keywords" content="${keyword}">
    <meta name="description" content="${seo_description}">
    <meta property="og:title" content="${title}"/>
    <meta property="og:url" content="${url}"/>
    <meta property="og:description" content="${seo_description}"/>
    <meta property="og:image" content="${image}"/>
    <meta property="og:image:width" content="960"/>
    <meta property="og:image:height" content="480"/>
    <meta property="og:image:alt" content="${title}"/>
    <meta property="og:type" content="article"/>
    <meta property="og:site_name" content="HONEYEE.COM"/>

    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:site" content="@honeyee_com"/>
    <meta name="twitter:creator" content="@honeyee_com"/>
    <meta name="twitter:title" content="${title}"/>
    <meta name="twitter:description" content="${title}">
    <meta name="twitter:image" content="${title}">
    <meta name="twitter:domain" content="https://www.honeyee.com"/>
    <script lang="javascript" src="/NativeShare.js"><\/script>`;
}

async function getWeixinConfig(params) {
  return CUSTOM_GET('https://api.knowherex.com/api/phpservice/open/weixin/get.config', params);
  //return CUSTOM_GET('http://localhost:8090/open/weixin/share2');
}

function getImgsrc(content = "") {
  let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
  let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
  let arr = content.match(imgReg); //筛选出所有的img
  let srcArr = [];
  if (arr) {
    for (let i = 0; i < arr.length; i++) {
      let src = arr[i].match(srcReg);
      // 获取图片地址
      srcArr.push(src[1]);
    }
  }
  return srcArr;
}

export default {
  components: {
    Header,
    Footer,
    aCarousel,
  },
  mixins: [Mixin],
  async asyncData({ store, route, req }) {
    let params = {
      controller: "index",
      action: "detail",
      id: route.params.id,
    };
    const data = await init(params);
    data.detail.href = "https://" + req.host + req.url;
    store.commit("detail/SET_DETAIL", data.detail);
    store.commit("detail/SET_CATEGORYS", data.categorys);
  },
  head() {
    const imgs = getImgsrc(this.content);
    let keyword;
    if (this.label) {
      keyword = this.label.join('|');
    }

    return {
      title: this.title,
      mataInfo: generateMeta({
        url: this.href,
        title: this.title,
        image: imgs[0],
        keyword: keyword,
        seo_description: this.seo_description || this.excerpt,
      }),
    };
  },
  data() {
    const initData = {
      isMask: false,
      id: "",
      coverImg: "",
      videoPost: "",
      videoUrl: "",
      content: "",
      weiboSharePic: [],
      date: "",
      title: "",
      label: [],
      href: "",
      sliderImg: [],
      textVal: [],
      isShare: false,
      isCode: false,
      excerpt: "",
      seo_description: "",
    };

    const {
      attached_file: weiboSharePic,
      wpcf_detail_header_image: coverImg,
      wpcf_detail_cover: videoPost,
      wpcf_detail_header_video: videoUrl,
      post_content: content,
      post_date: date,
      post_title: title,
      post_tag: label,
      ID: id,
      post_excerpt: excerpt,
      seo_description,
    } = this.$store.state.detail.data;

    const href = this.$store.state.detail.data.href;
    const shareUrls = {
      sharelink_ins: `http://www.instapaper.com/edit?url=${href}&title=${title}&description=@d`,
      sharelink_tw: `https://twitter.com/intent/tweet?url=${href}&title=${title}&hashtags=@h@tu=@d`,
      sharelink_weibo: `http://service.weibo.com/share/share.php?url=${href}&title=${title} ${date}&pic=${weiboSharePic}`,
      sharelink_fb: `https://www.facebook.com/sharer/sharer.php?u=${href}&title=${title}&description=@d&quote=@q&hashtag=@h`,
      sharelink_line: `https://lineit.line.me/share/ui?url=${href}`,
    };
    let slider =
      content &&
      content.match(/<p>Honeyee_Slider([\s\S]*?)Honeyee_SliderEnd<\/p>/g);

    let sliderImg = [];
    let textVal = [];

    if (slider) {
      slider.forEach((item, index) => {
        if (item) {
          let img = item.match(/src="([\s\S]*?)" alt=/g);
          let arr = [];
          img.forEach((val) => {
            let src = val.replace(/src="/g, "").replace(/" alt=/g, "");
            arr.push(src);
            sliderImg[index] = arr;
          });
        }
      });
      textVal = content.split("<p>Honeyee_Slider</p>");
    }
    let share = {};
    return {
      ...initData,
      id,
      date,
      label,
      title,
      href,
      textVal,
      content,
      coverImg,
      videoUrl,
      videoPost,
      sliderImg,
      weiboSharePic,
      excerpt,
      seo_description,
      ...shareUrls,
      share,
    };
  },
  customOption: {},
  mounted() {

  },
  created() {
    if (typeof window != "undefined") {
      this.nativeShareInit();
    }
  },
  beforeMount() {
    // this.setShareDomain();
  },
  methods: {
    // setShareDomain() {
    //   this.sharelink_ins = `http://www.instapaper.com/edit?url=${window.location.href}&title=${this.title}&description=@d`;
    //   this.sharelink_tw = `https://twitter.com/intent/tweet?url=${window.location.href}&title=${this.title}&hashtags=`;
    //   this.sharelink_weibo = `http://service.weibo.com/share/share.php?url=${window.location.href}&title=${this.title} ${this.date}&pic=${this.weiboSharePic}`;
    //   this.sharelink_fb = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&title=${this.title}&description=@d&quote=@q&hashtag=@h`;
    //   this.sharelink_line = `https://lineit.line.me/share/ui?url=${window.location.href}`;
    // },
    async nativeShareInit() {
      var url = window.location.href.split('#')[0];
      let weixinConfig = await getWeixinConfig({url});

      // 先创建一个实例
      var nativeShare = new NativeShare({
        wechatConfig: {
          appId: weixinConfig.appid,
          timestamp: weixinConfig.timestamp,
          nonceStr: weixinConfig.nonceStr,
          signature: weixinConfig.signature,
        },
        // 让你修改的分享的文案同步到标签里，比如title文案会同步到<title>标签中
        // 这样可以让一些不支持分享的浏览器也能修改部分文案，默认都不会同步
        syncDescToTag: false,
        syncIconToTag: false,
        syncTitleToTag: false,
      })
      nativeShare.setShareData({
        icon: this.coverImg,
        link: this.href,
        title: this.title,
        desc: this.excerpt,
        from: '@honeyee.com',
      })
      this.$options.customOption = nativeShare;
    },
    nativeShareCall() {
      this.$options.customOption.call();
    },
    postMessage(message) {
      if (window.wx) {
        window.wx.miniProgram.postMessage({ data: message }) // data就是详细方法啦
      }
    },
    showMask(show) {
      this.isMask = show;
    },
    openShare() {
      this.isShare = !this.isShare;
    },
    openWei() {
      this.isCode = !this.isCode;
    },
    copy() {
      var domUrl = document.createElement("input");
      domUrl.value = window.location.href;
      domUrl.id = "creatDom";
      document.body.appendChild(domUrl);
      domUrl.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      let creatDom = document.getElementById("creatDom");
      creatDom.parentNode.removeChild(creatDom);
      let message = "copied";
      this.toast(message, "success");
    },
    sharePage(shareType) {
      var shareLink = "";
      switch (shareType) {
        case "weibo":
          shareLink =
            "http://service.weibo.com/share/share.php?url=" +
            this.shareUrl +
            "&title=" +
            this.shareTitle +
            this.date +
            "&pic=" +
            this.bannerImg;
          break;
        case "facebook":
          shareLink =
            "https://www.facebook.com/sharer/sharer.php?u=" +
            this.shareUrl +
            "&title=" +
            this.shareTitle +
            "&description=@d&quote=@q&hashtag=@h";
          break;
        case "ins":
          shareLink =
            "http://www.instapaper.com/edit?url=" +
            this.shareUrl +
            "&title=" +
            this.shareTitle +
            "&description=@d";
          break;
        case "twitter":
          shareLink =
            "https://twitter.com/intent/tweet?url=" +
            this.shareUrl +
            "&text=" +
            this.shareTitle +
            "&hashtags=@h@tu=@d";
          break;
        default:
          shareLink = "";
      }
      window.open(
        shareLink,
        "_blank",
        "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=800, height=800,top=100,left=200"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(10, 10, 10, 0.6);
  }
  .cover {
    width: 100%;
    max-height: 1000px;
    img {
      width: 100%;
      max-height: 1000px;
    }
  }
  .video {
    width: 100%;
  }
  .video-iframe{
    width: 100%;
    ::v-deep iframe {
      width: 100% !important;
      video{
        width: 100% !important;       
      }
    }    
  }
  .share {
    position: fixed;
    top: 40%;
    right: 1%;
    width: 84px;
    text-align: center;
    z-index: 990;
    .title {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;
      color: #232323;
      margin-bottom: 30px;
    }
    .shareList {
      width: 36px;
      margin: 0 auto;
      p,
      a {
        display: block;
        width: 36px;
        height: 36px;
        margin-bottom: 20px;
        img {
          width: 100%;
        }
      }
      .hidden_weixin {
        display: none;
      }
    }
  }
  .mbShare {
    position: fixed;
    top: 25%;
    right: 20 * $px;
    z-index: 999;
    .shareIcon {
      width: 32 * $px;
      height: 32 * $px;
      margin-bottom: 15 * $px;
      img {
        width: 32 * $px;
      }
    }

    .mb-shareList {
      width: 32 * $px;
      p,
      a {
        display: block;
        margin-bottom: 15 * $px;
        img {
          width: 100%;
        }
      }
    }

    .mbQrcode {
      position: absolute;
      right: 0;
    }
  }
  .detail {
    width: 100%;
    margin-top: 100px;
    padding: 0 17.4%;
    position: relative;
    .title {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 28px;
      line-height: 32px;
      color: #232323;
    }
    .labelBox {
      margin-top: 16px;
      display: flex;
      a {
        display: flex;
        background: #646464;
        border-radius: 2px;
        font-family: Helvetica;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #ffffff;
        padding: 5px 10px;
        margin-right: 12px;
        align-items: center;
        height: 26px;
        cursor: pointer;
      }
    }
    .date {
      font-family: Helvetica;
      font-size: 12px;
      line-height: 20px;
      color: #787878;
      margin-top: 12px;
    }
    .content {
      margin-top: 24px;
      letter-spacing: 2px;
      overflow: hidden;
      ::v-deep.image {
        // text-align: center;
      }
      ::v-deep.wp-block-image {
        // width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        img {
          // width: 100%;
          height: auto;
        }
      }
      ::v-deep.wp-block-video {
        video {
          // width: 1000px;
        }
      }
      // ::v-deep.mb-10 {
      //   margin-bottom: 10px;
      // }
      // ::v-deep.mb-20 {
      //   margin-bottom: 20px;
      // }
      // ::v-deep.mb-25 {
      //   margin-bottom: 25px;
      // }
      // ::v-deep.mb-30 {
      //   margin-bottom: 30px;
      // }
      // ::v-deep.mb-50 {
      //   margin-bottom: 50px;
      // }
      // ::v-deep.mb-80 {
      //   margin-bottom: 80px;
      // }
      ::v-deep.disNone {
        display: none;
      }
      ::v-deep.has-text-align-center {
        text-align: center;
      }
    }
  }
  .bannerBox {
    width: 100%;
    text-align: center;
    .banner {
      display: flex !important;
      align-items: center;
      overflow: hidden;
      margin: 0 auto;
      img {
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }
    }
    ::v-deep.ant-carousel .slick-prev,
    .ant-carousel .slick-next {
      width: 50px;
      height: 50px;
      max-width: 50px;
      max-height: 50px;
      top: 45%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    ::v-deep.ant-carousel .slick-prev {
      left: 40px;
      z-index: 99;
    }
    ::v-deep.ant-carousel .slick-next {
      right: 40px;
      z-index: 99;
    }
  }
}

.ant-carousel > .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel > .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel > .custom-slick-arrow:before {
  display: none;
}
.ant-carousel > .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel > .slick-slide h3 {
  color: #fff;
}

@media screen and (max-width: 1200px) {
  .main {
    width: 100%;
    .cover {
      width: 100%;
      max-height: 650 * $px;
      // margin-top: 76 * $px;
      img {
        width: 100%;
        max-height: 100%;
      }
    }
    .video {
      width: 100%;
      max-height: 650 * $px;
      // margin-top: 76 * $px;
    }
   
    .detail {
      width: 100%;
      margin-top: 50 * $px;
      padding: 0 16 * $px;
      .title {
        font-family: Helvetica;
        font-weight: bold;
        // font-size: 18 * $px;
        // line-height: 28 * $px;
        color: #232323;
      }
      .labelBox {
        margin-top: 16 * $px;
        display: flex;
        span {
          display: flex;
          background: #646464;
          border-radius: 2px;
          font-family: Helvetica;
          font-style: normal;
          font-weight: normal;
          font-size: 12 * $px;
          line-height: 16 * $px;
          color: #ffffff;
          padding: 0 10 * $px;
          height: 26 * $px;
          align-items: center;
          margin-right: 12 * $px;
          margin-bottom: 12 * $px;
        }
      }
      .date {
        font-family: Helvetica;
        font-size: 12 * $px;
        line-height: 20 * $px;
        color: #787878;
        margin-top: 12 * $px;
      }
      .content {
        margin-top: 24 * $px;
        ::v-deep.image {
          // width: 100%;
          text-align: center;
          img {
            // width: 100%;
          }
        }
        ::v-deep.wp-block-image {
          width: 100%;
          display: flex;
          justify-content: center;
          // img {
          //   width: 100%;
          //   height: 100%;
          // }
        }
        ::v-deep.wp-block-video {
          width: 100%;
          display: flex;
          justify-content: center;
          video {
            width: 100%;
            height: 100%;
          }
        }
        // ::v-deep.mb-10 {
        //   margin-bottom: 10px;
        // }
        // ::v-deep.mb-20 {
        //   margin-bottom: 20px;
        // }
        // ::v-deep.mb-25 {
        //   margin-bottom: 25px;
        // }
        // ::v-deep.mb-30 {
        //   margin-bottom: 30px;
        // }
        // ::v-deep.mb-50 {
        //   margin-bottom: 50px;
        // }
        // ::v-deep.mb-80 {
        //   margin-bottom: 80px;
        // }
        ::v-deep.disNone {
          display: none;
        }
        ::v-deep.has-text-align-center {
          text-align: center;
        }
      }
    }
    .bannerBox {
      width: 100%;
      text-align: center;
      .banner {
        display: flex;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      ::v-deep.ant-carousel .slick-prev,
      .ant-carousel .slick-next {
        width: 40 * $px;
        height: 40 * $px;
        top: 45%;
      }
      ::v-deep.ant-carousel .slick-prev {
        left: 16 * $px;
        z-index: 99;
      }
      ::v-deep.ant-carousel .slick-next {
        right: 16 * $px;
        z-index: 99;
      }
    }
  }
}
@media screen and (min-width: 1023px) and (max-width: 1200px) {
  ::v-deep iframe {
    width: 100% !important;
    height: 292*$px!important;
    min-height: 292*$px !important;
    max-height: 362*$px!important;     
    video{
      object-fit: cover !important; 
    }     
  }
}
@media screen and (min-width: 750px) and (max-width: 1023px) {
  ::v-deep iframe {
    width: 100% !important;
    height: 232*$px!important;
    min-height: 232*$px !important;
    max-height: 300*$px!important;     
    video{
      object-fit: cover !important; 
    }     
  }
}

@media screen and (max-width: 750px) {
  .main {
    .cover,.video {
      margin-top: 76 * $px;
    }
    .detail {
      margin-top: 0;
    }   
    ::v-deep iframe{    
      margin-top: 76* $px !important;
      width: 100%!important;
      height: 211* $px !important;
      // min-height: 211* $px !important;
      // max-height: 243* $px!important;
    }  
  }
}
</style>



// WEBPACK FOOTER //
// Detail.vue